import { ServiceStatuses } from "@pages/candidate/detail/CandidateDVTJCUV";
import {
    JobFindModeOptions
} from '@pages/dvtjcuv/common/Constant';
import { set } from "lodash";
import React, { useState } from 'react';
import Select from "react-select";

const ServiceStatusOptions = Object.values(ServiceStatuses).map((item, index) => {
    return {value: item.id, label: item.title}
})

const DVTJCUVUseStatusFields = [
    {
        key: 'service_status',
        label: 'Trạng thái SD DV',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        editable: true,
        searchable: true,
        options: ServiceStatusOptions
    },
    {
        key: 'note',
        label: 'Note',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        capitalize: true,
        searchable: false
    },
    // {
    //     key: 'dvtjcuv_find_job_mode',
    //     label: 'Chế độ tìm job (DVTJCUV)',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'option',
    //     editable: true,
    //     isMulti: false,
    //     options: JobFindModeOptions,
    // },
    {
        key: 'start_first_active_date_time',
        label: 'Activate Time Start',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'end_first_active_date_time',
        label: 'Activate Time End',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'start_service_use_month',
        label: 'Thời hạn sử dụng DV (Months) from',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
    },
    {
        key: 'end_service_use_month',
        label: 'Thời hạn sử dụng DV (Months) to',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
    },
    {
        key: 'start_expiry_date_time',
        label: 'Expired Time Start',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: false,
        capitalize: true,
        searchable: false
    },
    {
        key: 'end_expiry_date_time',
        label: 'Expired Time End',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: false,
        capitalize: true,
        searchable: false
    },

    // {key: 'agreement', label: 'Agreement', classNames: '', displayType: 'text', inputType: 'text', editable: true, capitalize: true, searchable: false},

    // {key: 'service_status_history', label: 'History Trạng thái SD DV', classNames: '', displayType: 'text', inputType: 'number', editable: true, searchable: true},
    // {key: 'invoice_name', label: 'Tên Người được xuất hóa đơn', classNames: '', displayType: 'text', inputType: 'text', editable: true, capitalize: true, searchable: true},
    // {key: 'address', label: 'Địa chỉ', classNames: '', displayType: 'text', inputType: 'text', editable: true, capitalize: true, searchable: false},
    // {key: 'tax_code', label: 'Mã số thuế', classNames: '', displayType: 'text', inputType: 'text', editable: true, capitalize: true, searchable: false},
];



const CandidateSearchDVTJCUV = (props) => {
    const [currentUseTimes, setCurrentUseTimes] = useState({});
    const [statusOptions, setStatusOptions] = useState([...ServiceStatusOptions]);

    const {initDVTJCUV, onChange} = props

    const getSelectedStatusOption = (value) => {
        return ServiceStatusOptions.filter(
            item => item.value === value
        )[0] || {label: '', value: ''}
    }

    React.useEffect(() => {
        setCurrentUseTimes(initDVTJCUV || {});
    }, [initDVTJCUV]);

    const onChangeInput = (values, column) => {
        currentUseTimes[column.key] = values
        setCurrentUseTimes({...currentUseTimes})
        if (onChange) {
            onChange({...currentUseTimes} );
        }
    }

    const displayStatusFieldValues = (field) => {
        if (field.key === 'dvtjcuv_find_job_mode') {
            // find value in JobFindModeOptions
            return JobFindModeOptions.find(item => item.value.toString() === currentUseTimes[field.key].toString())
        }

        return currentUseTimes[field.key]
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>DVTJCUV</h3>
                </div>
                <div className='card-body'>
                    <div className={'row'}>
                        {DVTJCUVUseStatusFields.map((column) => {
                            if (column.inputType === 'option') {
                                const columnOptions = column.key === 'service_status' ? statusOptions : column.options
                                return <div className='col-sm-6' key={`CandidateDVTJCUV_input_item_${column.key}`}>
                                    <div className='form-group'>
                                        <div style={{width: '100%'}}>
                                            <label className={`w-100}`}>{column.label}</label>
                                            <Select options={columnOptions}
                                                    value={displayStatusFieldValues(column) || ''}
                                                    name={column.key}
                                                    isMulti={!!column.isMulti}
                                                    onChange={value => {
                                                        onChangeInput(value, column);
                                                    }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            return <div className='col-sm-6' key={`CandidateDVTJCUV_input_item_${column.key}`}>
                                <div className='form-group'>
                                    <label className={'w-100'}>{column.label}</label>
                                    <input type={column.inputType} className='form-control'
                                            value={currentUseTimes[column.key] || ''}
                                            name={column.key}
                                            onChange={event => onChangeInput(event.target.value, column)}/>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default CandidateSearchDVTJCUV;
